import React from 'react';
import './Integration.scss';
import ContentLoader from 'react-content-loader';
import IntHeader from './IntHeader';
// import ReactTooltip from 'react-tooltip';
// import { IconInformation } from '../../img';

const TripAdvisor = ({
  data,
  hideShowDataSource,
  // arrDataSource,
  // handleDataSource,
  userIntegration,
  createTripAdvisor,
  deleteTripAdvisor,
  handleStateChangeInt,
  validator,
  loading,
  // hideShowIntegration,
  openReviewModel,
  intInterValFn
}) => {
  if (userIntegration && userIntegration.length > 0) {
    userIntegration.filter(x => {
      if (x.inm === 'tripadvisor') {
        if (x.d && x.d.isListen === true && data.isCallInterVal === false) {
          intInterValFn();
        }
        return x;
      }
    });
  }
  return (
    <div>
      <div className="title-dataset-select">
        {/* <div className="dataset-select-header" >
          <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
            <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
          </svg>
          <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
            <img className="mr-2" src={data.img} alt="icon" />
            <h6>{data.dn}</h6>
          </div>
        
        </div> */}
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
        />
        <div className="wdgt-group-block wdgt-dataset-form  wdgt-group-ggplace">
          <div className="wdgt-group-input mt-15">
            <label>URL</label>
            <input className="nf-input nf-input-sm" name="curl" placeholder="Enter Capterra URL" value={data.curl} onChange={handleStateChangeInt} />
            {validator.message('url', data.curl, 'required|required')}
            {/* <p style={{ fontSize: '12px', color: '#212121' }}>e.g. https://www.tripadvisor.in/Restaurant_Review-g297612-d5903566-Reviews-Kansar_Gujarati_Thali-Surat_Surat_District_Gujarat.html#REVIEWS</p> */}
          </div>
          <div className="wdgt-group-input mt-15">
            <label>Enter Company name</label>
            <input className="nf-input nf-input-sm" name="rmk" value={data.rmk} placeholder="Enter Company name" onChange={handleStateChangeInt} />
            {validator.message('Company name', data.rmk, 'required|required')}
          </div>
          <div className="add-integra-btn text-center" onClick={(e) => createTripAdvisor(e)}>
            <a className="nf-btn nf-btn-default">Add New</a>
          </div>
        </div>
        {/* {userIntegration && userIntegration.length > 0 && data.isHideShowInt == false && <div className="integr-inside-hdright" onClick={() => hideShowIntegration()}>
          <div className="add-integra-btn text-center" >
            <a className="nf-btn tbl-seehty-btn">Add New</a>
          </div>
        </div>}
        {((typeof userIntegration == 'undefined' || typeof userIntegration == 'boolean') || (data.isHideShowInt == true)) && <div className="wdgt-group-block wdgt-group-ggplace">
          <div className="wdgt-group-input mt-25">
            <label>URL</label>
            <input className="nf-input nf-input-sm" name="curl" placeholder="Enter URL" value={data.curl} onChange={handleStateChangeInt} />
            {validator.message('url', data.curl, 'required|required')}
          </div>
          <div className="wdgt-group-input mt-15">
            <label>Enter Company name</label>
            <input className="nf-input nf-input-sm" name="rmk" value={data.rmk} placeholder="Enter Company name" onChange={handleStateChangeInt} />
            {validator.message('Company name', data.rmk, 'required|required')}
          </div>
          <div className="add-integra-btn text-center" onClick={(e) => createTripAdvisor(e)}>
            <a className="nf-btn nf-btn-default">Add New</a>
          </div>
        </div>}
        {userIntegration && userIntegration.length > 0 && <div className="integre-search--list">
          <input
            className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
            placeholder="Search by name"
            type="text"
            name="searchByName"
            value={data.searchByName}
            onChange={(e) => handleStateChangeInt(e)}
          />
        </div>} */}
        {loading === true ?
          <ContentLoader
            height={750}
            width={1750}
            speed={2}
            primaryColor="#fff"
            secondaryColor="#eceef4"
          >
            <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
          </ContentLoader>
          :
          <div className='sublistapp-connect-block'>
            <h5 className='title-connection'>Company list</h5>
            <div className='app-list-sublistapp'>
              <div className='integra-data-headerblock'>
                <label className=''>Name</label>
                <label className=''>Action</label>
              </div>
              <div className='review-collection-scroll' style={{ maxHeight: 'calc(100vh - 430px)' }}>
                {userIntegration && userIntegration.length > 0 ?
                  userIntegration.map((usInt, key) => {
                    if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
                    return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
                      <div className="integra-checklist-item" >
                        <span className="">{usInt.rmk}</span>
                        {usInt.d.isListen === true &&
                          <span className='btn-action nf-btn light-bg-icon btn-icon-20 tbl-action-rotet'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 19.996">
                              <path id="Path_59553" data-name="Path 59553" d="M52,17.379v6.207a1.378,1.378,0,0,1-1.379,1.379H44.414a1.379,1.379,0,0,1,0-2.759h2.732a6.886,6.886,0,1,0-5.5,11.026,6.83,6.83,0,0,0,4.133-1.377,1.38,1.38,0,0,1,1.657,2.206A9.565,9.565,0,0,1,41.652,36a9.651,9.651,0,1,1,7.59-15.59V17.379a1.379,1.379,0,1,1,2.759,0Z" transform="translate(-32 -16)" fill="#8392a5" />
                            </svg>
                          </span>
                        }
                        {usInt.d.isListen === false && <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
                          onClick={() => openReviewModel(usInt)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                            <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                          </svg>
                        </span>}
                        <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                          onClick={() => deleteTripAdvisor(usInt._id)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                            <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                              <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                              <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                            </g>
                          </svg>
                        </span>
                      </div>
                    </div>);
                  }) :
                  <div className="card-editor card-intigra-block card-intigra-ggpalceislist">
                    <div className="dataset-select-item">
                      <h5> No record found</h5>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
          // userIntegration && userIntegration.length > 0 ?
          //   userIntegration.map((usInt, key) => {
          //     if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
          //     let defaultChecked = arrDataSource.filter((dataSource) => {
          //       if (dataSource.uid == usInt._id && dataSource.pid == usInt._id) return true; return false;
          //     }).length > 0 ? true : false;
          //     let objCountParams = {
          //       pglkcnt: 0,
          //       pgflcnt: 0,
          //       pgrtngcnt: usInt.d.pgrtngcnt ? usInt.d.pgrtngcnt : 0,
          //       pgrtngavg: usInt.d.pgrtngavg ? usInt.d.pgrtngavg : 0,
          //       pu: '',
          //       url: usInt.d.url ? usInt.d.url : '',
          //       iin: usInt.inm,
          //       rmk: usInt.rmk,
          //       dn: usInt.d.dn ? usInt.d.dn : ''
          //     };
          //     if (usInt.d.isListen == true) {
          //       return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
          //         <div className="integra-checklist-item" >
          //           <ContentLoader
          //             height={200}
          //             width={1750}
          //             speed={2}
          //             primaryColor="#fff"
          //             secondaryColor="#eceef4"
          //             key={key}
          //           >
          //             <rect x="5" y="25" rx="0" ry="0" width="140" height="150"></rect>
          //             <rect x="200" y="25" rx="0" ry="0" width="1400" height="150"></rect>
          //           </ContentLoader>
          //           <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
          //             onClick={() => deleteTripAdvisor(usInt._id)}>
          //             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
          //               <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
          //                 <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
          //                 <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
          //               </g>
          //             </svg>
          //           </span>
          //         </div>
          //       </div>);
          //     } else {
          //       return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
          //         <div className="integra-checklist-item" >
          //           <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
          //             <label>
          //               <input type="checkbox"
          //                 name={usInt.d.place_id}
          //                 checked={defaultChecked}
          //                 onChange={(e) => handleDataSource(
          //                   usInt._id,
          //                   usInt._id,
          //                   e.target.checked,
          //                   objCountParams,
          //                   usInt
          //                 )}
          //               />
          //             </label>
          //           </div>
          //           <span className="">{usInt.rmk}</span>
          //           <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
          //             onClick={() => openReviewModel(usInt)}>
          //             {/* <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 14.233 14.164">
          //               <path id="Path_240" data-name="Path 240" d="M-31.27,55.361l2.9,2.9L-35.7,65.586l-2.894-2.9Zm5.092-.7-1.291-1.291a1.281,1.281,0,0,0-1.81,0l-1.237,1.237,2.9,2.9,1.443-1.443a.987.987,0,0,0,0-1.4Zm-13.935,12.1a.329.329,0,0,0,.4.392l3.226-.782-2.894-2.9Zm0,0" transform="translate(40.12 -52.998)" fill="#b0bec5"></path>
          //             </svg> */}
          //             <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
          //               <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
          //             </svg>
          //           </span>
          //           <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
          //             onClick={() => deleteTripAdvisor(usInt._id)}>
          //             <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
          //               <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
          //                 <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
          //                 <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
          //               </g>
          //             </svg>
          //           </span>
          //         </div>
          //       </div>);
          //     }
          //     // if (usInt.d.isListen == true) {
          //     //   return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-palceislist" key={key}>
          //     //     <div className="card-editor-block p-0">
          //     //       <label className="card-editor-title app-intigra-title">{usInt.rmk}</label>
          //     //       <div className="app-editor-actiontop app-intigra-actiontop">
          //     //         <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
          //     //           onClick={() => deleteTripAdvisor(usInt._id)}>
          //     //           <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
          //     //             <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
          //     //               <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
          //     //               <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
          //     //             </g>
          //     //           </svg>
          //     //         </span>
          //     //       </div>
          //     //       <div className="card-intigra-box">
          //     //         <div className="dataset-select-list">
          //     //           <div className="dataset-select-item">
          //     //             <ContentLoader
          //     //               height={200}
          //     //               width={1750}
          //     //               speed={2}
          //     //               primaryColor="#fff"
          //     //               secondaryColor="#eceef4"
          //     //               key={key}
          //     //             >
          //     //               <rect x="10" y="40" rx="0" ry="0" width="150" height="150"></rect>
          //     //               <rect x="220" y="40" rx="0" ry="0" width="1500" height="150"></rect>
          //     //             </ContentLoader>
          //     //           </div>
          //     //         </div>
          //     //       </div>
          //     //     </div>
          //     //   </div>);
          //     // } else {
          //     //   return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-palceislist" key={key}>
          //     //     <div className="card-editor-block p-0">
          //     //       <label className="card-editor-title app-intigra-title">{usInt.rmk}</label>
          //     //       <div className="app-editor-actiontop app-intigra-actiontop">
          //     //         <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
          //     //           onClick={() => deleteTripAdvisor(usInt._id)}>
          //     //           <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
          //     //             <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
          //     //               <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
          //     //               <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
          //     //             </g>
          //     //           </svg>
          //     //         </span>
          //     //       </div>
          //     //       <div className="card-intigra-box">
          //     //         <div className="dataset-select-list">
          //     //           <div className="dataset-select-item">
          //     //             <div className="secstyle-checkbox  itgtion-icon-checkboc">
          //     //               <label>
          //     //                 <input type="checkbox"
          //     //                   name={usInt.d.pgid}
          //     //                   checked={defaultChecked}
          //     //                   onChange={(e) => handleDataSource(
          //     //                     usInt._id,
          //     //                     usInt.d.pgid,
          //     //                     e.target.checked,
          //     //                     objCountParams
          //     //                   )}
          //     //                   disabled={usInt.d.isListen}
          //     //                 />
          //     //               </label>
          //     //               <span>{usInt.rmk}</span>
          //     //             </div>
          //     //           </div>
          //     //         </div>
          //     //       </div>
          //     //     </div>
          //     //   </div>);
          //     // }
          //   }) : ''
        }
      </div>
    </div>
  );
};


export default TripAdvisor;


// WEBPACK FOOTER //
// ./src/components/Integration/TripAdvisor.js